import React from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import { List } from 'material-ui/List';
import { Step, Stepper, StepButton } from 'material-ui/Stepper';
import Field from '../../components/Field';
import FieldLocation from '../../components/FieldLocation';
import SignupListItems from '../../components/SignupListItem';
import Logo from '../../components/Logo';
import { Redirect, Link } from 'react-router-dom';
import feathers from '../../feathers';
import { isStrongPassword } from '../../lib';
import { FacilityRecord } from '../../feathers/records';
import colors from '../../themes/colors';

import './style.scss';

export default class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.signupService = feathers.service('auth/signup');
    this.signupAbandonService = feathers.service('auth/signup-abandon');
    this.state = {
      redirect: null,
      error: null,
      fetching: false,
      emailSent: false,
      stepIndex: 0,
      data: {
        address: '',
        geo: [],
        first_name: '',
        last_name: '',
        account_name: '',
        email: '',
        password: ''
      }
    };
    autoBind(this);
  }

  handleNext = async () => {
    const { stepIndex } = this.state;
    if (stepIndex === 0) {
      await this.sendAbandonEmail();
    }
    if (stepIndex < 1) {
      this.setState({ stepIndex: stepIndex + 1 });
    }
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  handleChange({ name, value }) {
    this.setState({
      data: { ...this.state.data, [name]: value }
    });
  }

  getPasswordHelp(password) {
    if (!password) {
      return '';
    } else {
      return isStrongPassword(password)
        ? 'Great!'
        : 'Please enter a stronger password.';
    }
  }

  async sendAbandonEmail() {
    const { data, emailSent } = this.state;
    if (data.email && !emailSent) {
      try {
        await this.signupAbandonService.create(data);
      } catch (err) {
        //intentionally empty
      }
    }
    this.setState({ emailSent: true });
  }

  async redirectFirstFacility() {
    const newFacility = await FacilityRecord.find();
    const { _id: facilityId } = newFacility.data.toList().first();
    return `/map/${facilityId}?signup=true`;
  }

  getRewardfulReferral() {
    let rewardful_referral_id = null;
    let rewardful_referrer_token = null;
    if (window.Rewardful) {
      rewardful_referral_id = window.Rewardful.referral || null;
      rewardful_referrer_token = window.Rewardful.affiliate
        ? window.Rewardful.affiliate.token
        : null;
    }
    return { rewardful_referral_id, rewardful_referrer_token };
  }

  getSignupPayload({ rewardful_referral_id, rewardful_referrer_token }) {
    return {
      plan: this.props.location.query.plan || 'free',
      address: this.state.data.address,
      geo: {
        type: 'Point',
        coordinates: this.state.data.geo
      },
      first_name: this.state.data.first_name,
      last_name: this.state.data.last_name,
      email: this.state.data.email,
      password: this.state.data.password,
      account_name: this.state.data.account_name,
      rewardful_referral_id,
      rewardful_referrer_token
    };
  }

  async handleSubmit(event) {
    try {
      event.preventDefault();

      this.setState({
        fetching: true,
        error: false
      });

      const rewardfulData = this.getRewardfulReferral();
      const signupPayload = this.getSignupPayload(rewardfulData);
      let { user } = await this.signupService.create(signupPayload);
      await feathers._authenticate({
        strategy: 'local',
        email: user.email,
        password: signupPayload.password
      });
      let redirect = await this.redirectFirstFacility();
      this.setState({ redirect });
    } catch (err) {
      this.setState({
        error: err.message,
        fetching: false
      });
    }
  }

  canGoToStep2 = () => {
    const {
      first_name,
      last_name,
      account_name,
      email,
      password
    } = this.state.data;
    return !!(first_name && last_name && account_name && email && password);
  };

  canGoToStep3 = () => {
    return this.state.data.address.length && this.canGoToStep2();
  };

  render() {
    const { stepIndex, redirect, error, fetching, data } = this.state;
    if (redirect) {
      return <Redirect to={redirect} />;
    }
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-8 col-md-offset-2 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <div className="logo-container">
                  <div className="row">
                    <div className="col-sm-6">
                      <Logo width="200" />
                    </div>
                    <div className="col-sm-6">
                      <div style={{ textAlign: 'center' }}>
                        <h4 style={{ paddingTop: 12, paddingBottom: 5 }}>
                          Free Trial of MapPlug Beta Version
                        </h4>
                        <H3>No credit card. Start in seconds.</H3>
                      </div>
                    </div>
                  </div>
                </div>
                <Stepper linear activeStep={stepIndex}>
                  <Step>
                    <StepButton
                      onClick={() =>
                        this.setState({
                          stepIndex: 0
                        })
                      }
                    >
                      Account Setup
                    </StepButton>
                  </Step>
                  <Step>
                    <StepButton
                      onClick={() =>
                        this.setState({
                          stepIndex: 1
                        })
                      }
                    >
                      Facility Setup
                    </StepButton>
                  </Step>
                </Stepper>
                <div>
                  {stepIndex === 0 && (
                    <div className="row">
                      <div className="col-sm-6">
                        <List>
                          <SignupListItems text="Easily upload your floor plans to a satellite map of your location" />
                          <SignupListItems
                            text="Mark the locations of your HVAC units,
    gas cut-offs, fire extenguishers, and any
    cricital building asset"
                          />
                          <SignupListItems
                            text="Create custom markers and add any type
    of asset to your building"
                          />
                          <SignupListItems
                            text="Allow first responders to have your data
    in case of emergency"
                          />
                          <SignupListItems
                            text="Create step by step instructions so that any
    building occupant can handle a crisis"
                          />
                        </List>
                      </div>
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-xs-6">
                            <Field
                              disabled={fetching}
                              label="First Name"
                              name="first_name"
                              value={data.first_name}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="col-xs-6">
                            <Field
                              disabled={fetching}
                              label="Last Name"
                              name="last_name"
                              value={data.last_name}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12">
                            <Field
                              disabled={fetching}
                              label="Organization Name"
                              name="account_name"
                              value={data.account_name}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xs-12">
                            <Field
                              disabled={fetching}
                              label="Email"
                              name="email"
                              type="email"
                              value={data.email}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12"
                            style={{ marginBottom: 16 }}
                          >
                            <Field
                              autoComplete="new-password"
                              disabled={fetching}
                              label="Password"
                              type="password"
                              name="password"
                              value={data.password}
                              onChange={this.handleChange}
                              helpText={this.getPasswordHelp(data.password)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {stepIndex === 1 && (
                    <div className="row">
                      <div className="col-sm-6">
                        <H3>What do I get in the beta version?</H3>
                        <p style={{ padding: 16 }}>
                          - Use any plan size for free
                          <br />- Full access to the MapPlug software
                          <br />- Invite team members and staff
                          <br />- Future lifetime discount if you want it
                          <br />- Help is available to set up your facilities
                        </p>

                        <H3>Why is it free?</H3>
                        <p style={{ padding: 16 }}>
                          Since MapPlug is new, we are inviting people to try it
                          out for free for a few months so that we can learn how
                          to improve it. We just ask for some honest feedback
                          from you!
                        </p>
                      </div>
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-xs-12">
                            <FieldLocation
                              disabled={fetching}
                              label="Main building Street Address"
                              addressName="address"
                              geoName="geo"
                              geoValue={data.geo}
                              value={data.address}
                              onChange={this.handleChange}
                              helpText="Don't worry about suite numbers or address specifics! You will be able to fine tune your location by dragging a marker to its exact location."
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="well">
                              <H3>What happens after signing up?</H3>
                              <p style={{ padding: 16 }}>
                                After signing up here, you’ll be taken to a map
                                of your location and can start setting up your
                                buildings and assets. Someone will be on Live
                                Chat during work days to help you if you get
                                stuck!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div
                    className="row end-xs middle-xs"
                    style={{ marginTop: 12 }}
                  >
                    <div className="col-sm" style={{ textAlign: 'left' }}>
                      Already have an account?&nbsp;
                      <Link to="/login">Log In</Link>
                    </div>
                    <div className="col-sm">
                      <FlatButton
                        label="Back"
                        disabled={stepIndex === 0}
                        primary={true}
                        onClick={this.handlePrev}
                        style={{ marginRight: 12 }}
                      />
                      <FlatButton
                        label="Next"
                        disabled={stepIndex === 0 ? !this.canGoToStep2() : true}
                        primary={true}
                        onClick={async () => await this.handleNext()}
                        style={{ marginRight: 12 }}
                      />
                      <RaisedButton
                        label="Finish Signup!"
                        primary={true}
                        onClick={async event => await this.handleSubmit(event)}
                        disabled={!this.canGoToStep3()}
                      />
                    </div>
                  </div>
                </div>
              </Paper>
              {fetching && <LinearProgress mode="indeterminate" />}
              {error && <div className="unauthed-error">{error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const H3 = ({ children }) => <h3 style={{ color: colors.blue }}>{children}</h3>;



// WEBPACK FOOTER //
// ./src/pages/Signup/index.jsx